// @flow

import './TimelinePopup.css';
import * as React from 'react';
import Portal from './../common/Portal';
//import renderMetadataForm from './renderMetadataForm';
import renderMetadataForm, { isTypeTime } from '../metadata/renderMetadataForm';
import HashMap from '../protocol/HashMap';
import Popup from '../common/Popup';
import VideoController from './VideoController';
import { smpteToMillis, toSMPTE } from '../util/VideoUtil';
import _ from 'lodash';
import t from '../i18n/I18n';
import KeyboardShortcuts from '../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../keyboard-shortcuts/KeydownConfig';
import { KeyCode } from '../util/Constants';

const debug = require('../debug/debug')('wc:video:TimelinePopup');

type Props = {
  data: Object,
  controller: VideoController,
  style: Object,
  rect: ClientRect,
  offsetLeft: number,
  scrollLeft: number,
  isDrag: boolean,
  coordinates: {
    clientX: number,
    clientY: number
  },
  _node: HTMLElement,
  nodeContainer: Map<number, Object>,
  event: string,
  getPPS: Function,
  validateTimelineMoveAction: Function,
  setActioneAlert: Function,
  isAiNode: Function,
  popupRef: Function,
  onChange?: Function,
  onTimecodeChange: Function,
  onClose: Function,
  getRect: Function,
  onDelete?: Function,
  clearNodeContainer: Function,
  deletePopupOpen: Function,
  doPersistNodeContainer: Function,
  _nodeContainer: object
};

type State = {
  hashMap: HashMap,
  x: number,
  renderDeletePopup: boolean,
  _pureHashMap: HashMap
};

export default class TimelinePopup extends React.Component<Props, State> {
  _handle: 'startTimeMs' | 'stopTimeMs';
  _currentTimeAtDragStart: number;
  isTimeCodeChange: boolean;
  drag: boolean;
  data: Object;
  _dragOneEnd: boolean;
  stretch: Boolean;
  stopMoveTowardLeft: Boolean;
  stopMoveTowardRight: Boolean;
  nodeArray: Array<Object>;
  updatedNodeArray: Array<Object>;
  prevHashMap: HashMap;
  prevPureHashMap: HashMap;
  _pureHashMap: HashMap = new HashMap(); //Map which has original values. Unedited. To find out the change.

  constructor(props: Props) {
    super(props);
    this.drag = false;
    this._dragOneEnd = false;
    this.stretch = false;
    this.data = this.props.data;
    this.stopMoveTowardLeft = false;
    this.stopMoveTowardRight = false;
    this.nodeArray = [];
    this.updatedNodeArray = [];
    this.state = {
      hashMap: HashMap.fromObject(this.props.data),
      _pureHashMap: HashMap.fromObject(this.props.data),
      x: 0,
      renderDeletePopup: false
    };
    this.persistHashMapState();
    this.changeTimeCodesInMap();
  }

  changeTimeCodesInMap(): void {
    const hashMap = this.state.hashMap;
    if (debug.enabled) {
      debug('[changeTimeCodesInMap()] HashMap:', this.state._pureHashMap);
    }
    const keys: Array<any> = hashMap.keys();
    keys.forEach((k) => {
      let value = this.state.hashMap.get(k);
      if (isTypeTime(k)) {
        if (value <= 0) {
          value = 0;
        }
        if (typeof value === 'number') {
          const smpteTime = toSMPTE(value + this.props.controller.videoStartTimecode, this.props.controller.frameRate);
          if (debug.enabled) {
            debug('[changeTimeCodesInMap] Processed: K=%s V=%o', k, smpteTime);
          }
          hashMap.put(k, smpteTime);
          this.isTimeCodeChange = true;
        }
      }
    });
  }

  componentDidMount() {
    this.props.popupRef(this);
    this.addKeyEventListener();
  }

  componentWillUnmount() {
    this.removeListeners();
    this.removeKeyEventListener();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.nodeContainer.size) {
      const nextNode = HashMap.fromObject(nextProps.nodeContainer.values().next().value);
      const nextPureNode = HashMap.fromObject(nextProps.nodeContainer.values().next().value);
      const currentNode = this.state._pureHashMap;
      if ((this.drag && !nextProps.isDrag) || currentNode.get('id') !== nextNode.get('id')) {
        this.updateHashMapData(nextNode, nextPureNode);
      } else if (
        nextProps.data.startTimeMs !== this.props.data.startTimeMs &&
        nextProps.data._id === this.state.hashMap.get('_id')
      ) {
        this.updateHashMapData(nextNode, nextPureNode);
      } else {
        this.changeTimeCodesInMap();
      }
    }
  }

  updateHashMapData = (nextNode: hashMap, nextPureNode: hashMap) => {
    this.isTimeCodeChange = false;
    this.setState(
      {
        hashMap: nextNode,
        _pureHashMap: nextPureNode
      },
      this.changeTimeCodesInMap
    );
  };
  onKeyDownESCAPE = () => {
    if (this.props.nodeContainer.size == 1) {
      this.props.clearNodeContainer();
      this.forceUpdate();
    }
  };
  addKeyEventListener = () => {
    document.addEventListener('keydown', this.onPressArrowKey);
    document.addEventListener('keyup', this.onArrowKeyUp);
    KeyboardShortcuts.add(new KeydownConfig('TIMELINE_POPUP', this.onKeyDownESCAPE, [KeyCode.ESCAPE]));
  };

  removeKeyEventListener = () => {
    document.removeEventListener('keydown', this.onPressArrowKey);
    document.removeEventListener('keyup', this.onArrowKeyUp);
    KeyboardShortcuts.remove('TIMELINE_POPUP');
  };

  getMinMaxTime = (dataArray: Array<object>) => {
    let minStartTimeLocal = this.props.controller.duration * 1000;
    let maxStopTimeLocal = 0;
    dataArray.forEach((node) => {
      if (minStartTimeLocal > (node.startTime === undefined ? node.startTimeMs : node.startTime)) {
        minStartTimeLocal = node.startTime === undefined ? node.startTimeMs : node.startTime;
      }
      if (maxStopTimeLocal < (node.stopTime === undefined ? node.stopTimeMs : node.stopTime)) {
        maxStopTimeLocal = node.stopTime === undefined ? node.stopTimeMs : node.stopTime;
      }
    });
    return { minStartTimeLocal, maxStopTimeLocal };
  };

  onArrowKeyUp = _.debounce((e) => {
    //if ((e.code === 'ArrowLeft' || e.code === 'ArrowRight') && e.target.tagName !== 'INPUT')
    if (
      (e.code === 'ArrowLeft' || e.code === 'ArrowRight' || e.code === 'ShiftLeft' || e.code === 'ShiftRight') &&
      e.target.tagName !== 'INPUT'
    )
      this.updateMovedNode();
  }, 500);

  updateMovedNode = () => {
    const { updateKeyframeMetadataData, nodeContainer } = this.props;
    if (this.updatedNodeArray.length) {
      updateKeyframeMetadataData(this.updatedNodeArray);
      this.updatedNodeArray = [];
      this.nodeArray = [];
    }
    if (nodeContainer.size === 1) {
      this.updateSingleTimeline();
    }
  };

  onPressArrowKey = (e: KeyboardEvent) => {
    const { nodeContainer, validateTimelineMoveAction, setActioneAlert } = this.props;
    this.persistHashMapState();
    const fps = 1 / this.props.controller.frameRate;
    const step = fps * 1000;
    const maxStopTime = this.props.controller.duration * 1000;
    this.isShiftKeyPress = e.shiftKey;
    if ((e.code === 'ArrowLeft' || e.code === 'ArrowRight') && e.target.tagName !== 'INPUT') {
      if (validateTimelineMoveAction('move')) {
        if (nodeContainer.size === 1) this.moveSingleNodeByArrowKey(step, e.code, maxStopTime, 0);
        else if (nodeContainer.size > 1) {
          this.moveMultipleNodeByArrowKey(nodeContainer, e.code, step, maxStopTime);
        } else {
          //do nothing.
        }
      } else {
        setActioneAlert(t('NOT_SUPPORT_MOVE_ACTION'));
      }
    }
  };

  moveMultipleNodeByArrowKey = (nodeContainer: hashMap, key: string, step: number, maxStopTime) => {
    let { minStartTimeLocal, maxStopTimeLocal } = this.getMinMaxTime(
      this.updatedNodeArray.length ? this.updatedNodeArray : nodeContainer
    );
    if (!this.nodeArray.length) {
      this.nodeArray = [];
      nodeContainer.forEach((node) => {
        const { time } = this.getUpdatedTime(key, step, node.stopTimeMs, node.startTimeMs, maxStopTime);
        const { newStartTime, newStopTime } = this.getEdge(
          minStartTimeLocal,
          maxStopTimeLocal,
          maxStopTime,
          node.startTimeMs,
          node.stopTimeMs,
          time,
          key
        );
        let nodeObj = this.getNodeObj(newStartTime, newStopTime, node);
        this.resizedLine(nodeObj.startTime, nodeObj.stopTime, node._id);
        this.nodeArray.push(nodeObj);
      });
      this.updatedNodeArray = this.nodeArray;
    } else {
      this.nodeArray = [];
      this.updatedNodeArray.forEach((node) => {
        const { time } = this.getUpdatedTime(key, step, node.stopTime, node.startTime, maxStopTime);
        const { newStartTime, newStopTime } = this.getEdge(
          minStartTimeLocal,
          maxStopTimeLocal,
          maxStopTime,
          node.startTime,
          node.stopTime,
          time,
          key
        );
        let nodeObj = this.getNodeObj(newStartTime, newStopTime, node.data);
        this.resizedLine(nodeObj.startTime, nodeObj.stopTime, nodeObj.data._id);
        this.nodeArray.push(nodeObj);
      });
      this.updatedNodeArray = this.nodeArray;
    }
  };

  getNodeObj = (startTime: number, stopTime: number, data: object) => {
    let nodeObj = {
      startTime: startTime,
      stopTime: stopTime,
      startTimeMs: 'startTimeMs',
      stopTimeMs: 'stopTimeMs',
      data: data
    };
    return nodeObj;
  };

  getEdge = (
    minStartTimeLocal: number,
    maxStopTimeLocal: number,
    maxStopTime: number,
    startTime: number,
    stopTime: number,
    time: number,
    key: string
  ) => {
    let newStartTime, newStopTime;
    if (key === 'ArrowLeft') {
      if (minStartTimeLocal - 10000 <= 0 && this.isShiftKeyPress) {
        newStartTime = startTime - minStartTimeLocal;
        newStopTime = stopTime - minStartTimeLocal;
      } else {
        newStartTime = startTime + time;
        newStopTime = stopTime + time;
      }
    }
    if (key === 'ArrowRight') {
      if (maxStopTimeLocal + 10000 >= maxStopTime && this.isShiftKeyPress) {
        newStartTime = startTime + (maxStopTime - maxStopTimeLocal);
        newStopTime = stopTime + (maxStopTime - maxStopTimeLocal);
      } else {
        newStartTime = startTime + time;
        newStopTime = stopTime + time;
      }
    }
    return { newStartTime, newStopTime };
  };

  getUpdatedTime = (
    key: string,
    step: number,
    endTime: number,
    startTime: number,
    maxStopTime: number,
    difference: number
  ) => {
    let updatedStartTime, updatedStopTime, time;
    if (key === 'ArrowLeft') {
      this.stopMoveTowardRight = false;
      if (this.isShiftKeyPress) {
        if (startTime - 10000 <= 0) {
          updatedStartTime = 0;
          updatedStopTime = endTime - startTime;
          time = 0;
          this.stopMoveTowardLeft = true;
        } else {
          updatedStartTime = startTime - 10000;
          updatedStopTime = endTime - 10000;
          time = -10000;
          if (this.stopMoveTowardLeft) time = 0;
        }
      } else {
        if (startTime - step < 0) {
          updatedStartTime = 0;
          updatedStopTime = endTime - startTime;
          time = 0;
          this.stopMoveTowardLeft = true;
        } else {
          updatedStartTime = startTime - step;
          updatedStopTime = endTime - step;
          if (this.stopMoveTowardLeft) time = 0;
          else time = -step;
        }
      }
    }
    if (key === 'ArrowRight') {
      this.stopMoveTowardLeft = false;
      if (this.isShiftKeyPress) {
        if (endTime + 10000 >= maxStopTime) {
          updatedStartTime = maxStopTime - difference;
          updatedStopTime = maxStopTime;
          time = 0;
          this.stopMoveTowardRight = true;
        } else {
          updatedStartTime = startTime + 10000;
          updatedStopTime = endTime + 10000;
          time = 10000;
          if (this.stopMoveTowardRight) time = 0;
        }
      } else {
        if (endTime + step + 1 >= maxStopTime) {
          updatedStartTime = maxStopTime - difference;
          updatedStopTime = maxStopTime;
          time = 0;
          this.stopMoveTowardRight = true;
        } else {
          updatedStartTime = startTime + step + 1;
          updatedStopTime = endTime + step + 1;
          time = step + 1;
          if (this.stopMoveTowardRight === true) time = 0;
          else time = step + 1;
        }
      }
    }
    return { updatedStartTime, updatedStopTime, time };
  };

  moveSingleNodeByArrowKey = (step: Number, key: string, maxStopTime: number, minStartTime: number) => {
    let hashmap = this.state.hashMap;
    const { endTime, startTime } = this.getStartStopTimeInMillis();
    const difference = endTime - startTime;
    let { updatedStartTime, updatedStopTime } = this.getUpdatedTime(
      key,
      step,
      endTime,
      startTime,
      maxStopTime - 1,
      difference
    );
    hashmap.put('startTimeMs', updatedStartTime);
    hashmap.put('stopTimeMs', updatedStopTime);
    this.resizedLine(
      hashmap.get('startTimeMs'),
      hashmap.get('stopTimeMs'),
      this.props.nodeContainer.values().next().value._id
    );
    this.persistHashMapState();
    this.changeTimeCodesInMap();
    this.forceUpdate();
  };

  getStartStopTimeInMillis = () => {
    let endTime =
      typeof this.prevHashMap.get('stopTimeMs') === 'string'
        ? smpteToMillis(this.state.hashMap.get('stopTimeMs'), this.props.controller.frameRate)
        : this.prevHashMap.get('stopTimeMs');
    let startTime =
      typeof this.prevHashMap.get('startTimeMs') === 'string'
        ? smpteToMillis(this.state.hashMap.get('startTimeMs'), this.props.controller.frameRate)
        : this.prevHashMap.get('startTimeMs');
    if (debug.enabled) {
      debug('[getStartStopTimeInMillis()] endTime: %d,starttTime: %d', endTime, startTime);
    }
    return { endTime, startTime };
  };

  resizedLine = (startTime: number, stopTime: number, id: number) => {
    if (debug.enabled) {
      debug('[resizedLine()] node resizing function is called');
    }
    const { _node, getPPS, nodeContainer } = this.props;
    const line = _node.querySelector(`[id="${id}"]`);
    line.setAttribute('x1', (startTime / 1000) * getPPS());
    line.setAttribute('x2', (stopTime / 1000) * getPPS());
    this.forceUpdate();
  };

  addListeners = () => {
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.onMouseUp);
  };

  removeListeners = () => {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  };

  onMouseDownStartTime = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this._handle = 'startTimeMs';
    this.onMouseDown(e);
  };

  onMouseDownEndTime = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this._handle = 'stopTimeMs';
    this.onMouseDown(e);
  };

  onMouseDown = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this._currentTimeAtDragStart = this.props.controller.currentTime;
    if (!this.props.isAiNode(this.stretchData)) {
      this.addListeners();
      this.stretch = true;
      this.setState({ x: e.clientX });
    } else {
      this.props.setActioneAlert(t('NOT_SUPPORT_RESIZE_ACTION'));
    }
  };

  resizedNodeView = () => {
    const { _node, getRect } = this.props;
    if (_node) {
      const { left, width } = getRect(this.currentNodeData);
      const line = _node.querySelector(`[id="${this.currentNodeData._id}"]`);
      const x1 = line.getAttribute('x1');
      const x2 = line.getAttribute('x2');
      const difference = this.state.x - left;
      if (this._handle === 'startTimeMs') {
        const newX1 = parseInt(x1) + parseInt(difference);
        if (parseInt(x2) > newX1) line.setAttribute('x1', newX1);
      }
      if (this._handle === 'stopTimeMs') {
        const newX2 = parseInt(x2) + parseInt(difference) - width;
        if (parseInt(x1) < newX2) {
          line.setAttribute('x2', newX2);
        }
      }
    }
  };

  validateResizedTime = (e) => {
    const { offsetLeft, scrollLeft, getPPS, data, nodeContainer, controller } = this.props;
    const left = e.clientX - offsetLeft + scrollLeft;
    const seconds = left / getPPS();
    let millis = Math.round(seconds * 1000);
    const fps = 1 / controller.frameRate;
    const step = fps * 1000;
    const oneSecond = 1000;
    if (this._handle === 'stopTimeMs') {
      if (millis > this.currentNodeData.startTimeMs + oneSecond) this.millis = millis;
      else this.millis = this.currentNodeData.startTimeMs + oneSecond;
      if (millis > controller.duration * 1000) this.millis = controller.duration * 1000;
      else '';
    }
    if (this._handle === 'startTimeMs') {
      if (millis < this.currentNodeData.stopTimeMs - oneSecond) this.millis = millis;
      else this.millis = this.currentNodeData.stopTimeMs - oneSecond;

      if (millis < 0) this.millis = 0;
      else '';
    }
  };

  onMouseMove = (e: MouseEvent) => {
    const { offsetLeft, scrollLeft, getPPS, nodeContainer } = this.props;
    const left = e.clientX - offsetLeft + scrollLeft;
    const seconds = left / getPPS();
    this.currentNodeData = this.stretchData;
    this.validateResizedTime(e);
    if (nodeContainer.size === 1) {
      if (nodeContainer.values().next().value._id === this.currentNodeData._id) {
        const smpteTime = toSMPTE(this.millis, this.props.controller.frameRate);
        this.state.hashMap.put(this._handle, smpteTime);
      }
    }
    this._dragOneEnd = true;
    this.props.controller.setCurrentTime(seconds, true);
    this.setState({ x: e.clientX });

    this.resizedNodeView();
  };

  onMouseUp = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.stretch = false;
    this.props.onTimecodeChange(this._handle, this.millis, this.currentNodeData);
    this._dragOneEnd = false;
    this.props.controller.setCurrentTime(this._currentTimeAtDragStart, true);
    this.props.doPersistNodeContainer(true);
    this.removeListeners();
  };

  persistHashMapState = () => {
    this.prevHashMap = this.state.hashMap;
    this.prevPureHashMap = this.state._pureHashMap;
  };

  onChange = (e: Event, field: Object, data: string) => {
    if (debug.enabled) {
      debug('[onChange()] e: %o,field: %o, data: %s', e, field, data);
    }
    const { hashMap } = this.state;
    let key: string = '';
    if (field) {
      if (field.key) {
        key = field.key;
      } else {
        key = field.label;
      }
    }
    if (data == '' || data) key = 'value';
    let value = null;
    if (false && isTypeTime(key)) {
      //$FlowFixMe - e.target.value is not recognized by flow
      value = smpteToMillis(e.target.value, this.props.controller.frameRate);
      value = value - this.props.controller.videoStartTimecode;
    } else {
      //$FlowFixMe - e.target.value is not recognized by flow
      value = data == '' || data ? data : e.target.value;
    }

    if (value == '') this._nodeContainer = this.props.nodeContainer.values().next().value;
    if (value !== hashMap.get(key)) {
      hashMap.put(key, value);
      this.setState(
        {
          hashMap
        },
        this.persistHashMapState
      );
    }
  };

  validateTimeCode = (timeInMillis: number, key: string) => {
    const startTime = this.prevPureHashMap.get('startTimeMs');
    const stopTime = this.prevPureHashMap.get('stopTimeMs');
    if (startTime === undefined || stopTime === undefined) return false;
    if (isNaN(timeInMillis) || timeInMillis < 0) return false;
    if (key === 'startTimeMs') {
      if (timeInMillis >= this.prevHashMap.get('stopTimeMs')) return false;
      else return true;
    }
    if (key === 'stopTimeMs') {
      if (timeInMillis <= this.prevHashMap.get('startTimeMs')) return false;
      if (timeInMillis >= this.props.controller.duration * 1000) return false;
      else return true;
    }
    return true;
  };

  validateInputs = () => {
    const { controller } = this.props;
    const keys: Array<any> = this.prevHashMap.keys();
    keys.forEach((k) => {
      let value: string = this.prevHashMap.get(k);
      if (isTypeTime(k)) {
        let timeInMillis = null;
        if (typeof value === 'string') timeInMillis = smpteToMillis(value, this.props.controller.frameRate);
        else timeInMillis = value; //smpteToMillis(toSMPTE(value, this.props.controller.frameRate));
        timeInMillis = timeInMillis - this.props.controller.videoStartTimecode;
        if (!this.validateTimeCode(timeInMillis, k)) {
          timeInMillis = this.prevPureHashMap.get(k);
        }
        if (debug.enabled) {
          debug('[validateInputs()] Key: %s %s -> %s', k, this.prevPureHashMap.get(k), timeInMillis);
        }
        this.prevHashMap.put(k, timeInMillis);
      }
    });
    return !this.prevHashMap.equals(this.prevPureHashMap) ? this.prevHashMap : null;
  };

  onClose = () => {
    const { onClose } = this.props;
    if (this.updateSingleTimeline()) onClose();
  };

  updateSingleTimeline = () => {
    const { onClose, onChange, isDrag } = this.props;
    let formData: HashMap = null;
    if ((formData = this.validateInputs()) != null && _.isFunction(onChange) && !isDrag) {
      onChange(formData, this._nodeContainer);
      if (debug.enabled) {
        debug('[updateSingleTimeline()] single node gets updated', formData);
      }
      return true;
    } else return false;
  };

  setShowDeletePopoverState = () => {
    this.setState({
      renderDeletePopup: true
    });
  };

  onDelete = (e) => {
    const { onDelete, onClose } = this.props;
    if (onDelete) {
      onDelete();
    }
    onClose();
  };

  getArrayOfPortals = (style: string, isKeyframeMetadata: boolean, nodeContainer: Map<Number, Object>) => {
    let NodeArray = [];

    nodeContainer.forEach((node) => {
      let { top, left, width, height } = this.props.getRect(node);
      if (height) {
        top = top + height / 2;
      }
      const stopLeft = left + width;
      const startStyle = { top, left: left + 2, width: 5, height: 20, borderRadius: 4 };
      const stopStyle = { top, left: stopLeft - 2, width: 5, height: 20, borderRadius: 4 };
      NodeArray.push(this.getPortal(style, style, isKeyframeMetadata, startStyle, stopStyle, node._id));
    });
    return <div>{NodeArray ? NodeArray : null}</div>;
  };

  getPortal = (
    startButtonClass: string,
    stopButtonClass: string,
    isKeyframeMetadata: boolean,
    startStyle: Object,
    stopStyle: Object,
    key: number
  ) => {
    const { maxLeft, maxTop, minLeft, minTop } = this.props.getBoundaryOfRows();
    return (
      <Portal defaultOpen={isKeyframeMetadata} closeOnEsc={true} closeOnOutsideClick={true} key={key}>
        <span name="TimelinePopup">
          {startStyle.left >= minLeft &&
          startStyle.left <= maxLeft &&
          startStyle.top >= minTop &&
          startStyle.top <= maxTop ? (
            <button className={startButtonClass} style={startStyle} onMouseDown={this.onMouseDownStartTime} />
          ) : null}
          {stopStyle.left >= minLeft &&
          stopStyle.left <= maxLeft &&
          stopStyle.top >= minTop &&
          stopStyle.top <= maxTop ? (
            <button className={stopButtonClass} style={stopStyle} onMouseDown={this.onMouseDownEndTime} />
          ) : null}
        </span>
      </Portal>
    );
  };

  getStyleRangeOfDeletePopup = (style: object) => {
    let popupStyle = style;
    const { maxLeft, maxBottom, minLeft, minBottom } = this.props.getBoundaryOfRows();
    if (style.left >= maxLeft) {
      popupStyle.left = maxLeft;
    }
    if (style.left <= minLeft) {
      popupStyle.left = minLeft;
    }
    if (style.bottom > maxBottom) {
      popupStyle.bottom = maxBottom;
    }
    if (style.bottom < minBottom) {
      popupStyle.bottom = minBottom;
    }
    return popupStyle;
  };

  getDeletePopUp = (
    style: Object,
    hashMap: HashMap,
    data: Object,
    timelineDeleteFunc: () => void,
    onClose: () => void,
    clearNodeContainer: () => void
  ) => {
    let { renderDeletePopup } = this.state;
    const popupStyle = this.getStyleRangeOfDeletePopup(style);
    if (this.isTimeCodeChange)
      return (
        <div>
          {!renderDeletePopup ? (
            <Popup
              style={popupStyle}
              onClose={this.updateSingleTimeline}
              styleClass={'transparent-background-selectable timeline-popup'}
              bottom>
              <div
                name="TimelinePopup"
                onKeyUp={(e) => {
                  if (e.keyCode === 13) {
                    clearNodeContainer();
                    this.forceUpdate();
                  }
                }}>
                {renderMetadataForm(
                  hashMap,
                  this.onChange,
                  false,
                  true,
                  this.props.deleteMultipleNodes,
                  !this.props.nodeContainer.values().next().value.isKeyFrameData,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  this.props.controller,
                  '',
                  'TimelinePopup'
                )}
              </div>
            </Popup>
          ) : null}
        </div>
      );
    else return null;
  };

  setTopOfRect = (height: number, top: number) => {
    if (height) {
      return (top = top + height / 2);
    } else return top;
  };

  render() {
    const {
      data,
      style,
      rect,
      nodeContainer,
      onClose,
      clearNodeContainer,
      isPopupHide,
      onDelete,
      event,
      isAiNodePresent,
      isDrag,
      coordinates
    } = this.props;
    if (!this.state.x && !this.drag) this.data = data;
    if (!this.stretch) this.stretchData = data;
    let { top, left, width, height, bottom } = rect;
    top = this.setTopOfRect(height, top);

    const x1 = rect.x,
      y1 = rect.y;
    const x2 = rect.x + width,
      y2 = rect.y;
    const { hashMap, x, renderDeletePopup } = this.state;
    const hoverStylestart = { top, left: left + 2 };
    const hoverStylestop = { top, left: left + width - 2 };
    const startStyle = { top, left };
    const stopStyle = { top, left: left + width };

    if (isPopupHide) return null;

    if (this._handle === 'startTimeMs') {
      startStyle.left = startStyle.left + this.state.x;
    }

    if (this._handle === 'stopTimeMs') {
      stopStyle.left = stopStyle.left + this.state.x;
    }
    const isKeyframeMetadata = !!this.data && !!this.data.key && !!this.data.value;
    const timelineDeleteFunc =
      this.props.nodeContainer.values().next().value && this.props.nodeContainer.values().next().value.isKeyFrameData
        ? this.setShowDeletePopoverState
        : this.data.isKeyFrameData
        ? this.setShowDeletePopoverState
        : null;
    const { oneEndStartButtonStyle, oneEndStopButtonStyle } = this.getOneEndstate(x1, x2, y1, y2, coordinates);
    if (nodeContainer.size === 1) {
      let { top, left, width, height } = this.props.getRect(nodeContainer.values().next().value);
      top = this.setTopOfRect(height, top);
      const style1 = { bottom: window.innerHeight - top + 18, left: left + width / 2 };
      let widthRect = this.props.rect.width;
      if (!isDrag) {
        this.drag = false;
        return (
          <div>
            {oneEndStartButtonStyle && (widthRect > 6 || this.data.id == nodeContainer.values().next().value.id)
              ? this.getPortal(
                  oneEndStartButtonStyle,
                  oneEndStopButtonStyle,
                  isKeyframeMetadata,
                  hoverStylestart,
                  hoverStylestop
                )
              : null}
            {this.getDeletePopUp(style1, hashMap, this.data, timelineDeleteFunc, onClose, clearNodeContainer)}
            {!this.state.renderDeletePopup ? this.getArrayOfPortals('handle', isKeyframeMetadata, nodeContainer) : null}
            {event === 'mouseenter' || oneEndStartButtonStyle
              ? this.getPortal('hover-handle', 'hover-handle', isKeyframeMetadata, hoverStylestart, hoverStylestop)
              : null}
          </div>
        );
      } else {
        this.drag = true;
        return null;
      }
    } else {
      if (!isDrag && coordinates) {
        if (oneEndStartButtonStyle != null && width > 6) {
          return (
            <div>
              {this.getPortal(
                oneEndStartButtonStyle,
                oneEndStopButtonStyle,
                isKeyframeMetadata,
                hoverStylestart,
                hoverStylestop
              )}
              {this.getArrayOfPortals('handle', isKeyframeMetadata, nodeContainer)}
            </div>
          );
        } else {
          if (nodeContainer.size === 0 && event === 'mouseenter') {
            return this.getPortal('hover-handle', 'hover-handle', isKeyframeMetadata, hoverStylestart, hoverStylestop);
          } else {
            if (event === 'mouseenter') {
              return (
                <div>
                  {this.getPortal('hover-handle', 'hover-handle', isKeyframeMetadata, hoverStylestart, hoverStylestop)}
                  {this.getArrayOfPortals('handle', isKeyframeMetadata, nodeContainer)}
                </div>
              );
            } else {
              return this.getArrayOfPortals('handle', isKeyframeMetadata, nodeContainer);
            }
          }
        }
      } else return null;
    }
  }
  getOneEndstate = (x1, x2, y1, y2, coordinates) => {
    if (coordinates) {
      if (
        x1 - 2 < coordinates.clientX &&
        x1 + 6 > coordinates.clientX &&
        y1 - 5 < coordinates.clientY &&
        y1 + 8 > coordinates.clientY
      ) {
        return {
          oneEndStartButtonStyle: 'handle',
          oneEndStopButtonStyle: 'handle-hover'
        };
      } else if (
        x2 > coordinates.clientX &&
        x2 - 8 < coordinates.clientX &&
        y2 + 8 > coordinates.clientY &&
        y2 - 5 < coordinates.clientY
      ) {
        return {
          oneEndStartButtonStyle: 'handle-hover',
          oneEndStopButtonStyle: 'handle'
        };
      } else
        return {
          oneEndStartButtonStyle: null,
          oneEndStopButtonStyle: null
        };
    } else
      return {
        oneEndStartButtonStyle: null,
        oneEndStopButtonStyle: null
      };
  };
}
